<template style="height: 100%;">
  <div class="Details">
    <div class="activity_Details">
      
      <div style="font-family: SourceHanSansSC;font-size: 18px;color: rgb(51, 51, 51);font-style: normal;letter-spacing: 0px;text-decoration: none;margin-left: 20px;padding-bottom: 10px;font-weight: 700;margin-top: 10px;">
        {{ DetailsList.subject }}

        <!-- <span style="font-size: 13px;padding: 5px;color: rgba(24, 139, 255, 1);background-color: rgb(223, 239, 255);">{{ DetailsList.state }}</span> -->
      </div>

      <div class="spanstyle">
        <span>活动分类：{{ DetailsList.classificationStr }}</span>
        <span>活动说明：{{ DetailsList.evenContent }} </span>
        <!-- <span>是否同步论坛：{{ DetailsList.syncChart == 1 ? '是' : '否' }}</span> -->
        <br/>
      </div>
    </div>

    <div class="tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="概况信息" name="first">
          <div style="font-family: SourceHanSansSC;font-weight: 700;font-size: 18px;color: rgb(16, 16, 16);font-style: normal;letter-spacing: 0px;text-decoration: none;padding-bottom: 10px;">
            基本信息
          </div>
          <div class="cotent">
            <table style="width: 100%; border-spacing: 0px">
              <tr>
                <td class="title" width="20%">访问量</td>
                <td width="30%">
                  {{ DetailsList.visitCount }}
                </td>
                <td class="title"  width="20%">点击数</td>
                <td width="30%">{{ DetailsList.viewCount }}</td>
              </tr>
              <tr>
                <td class="title"  width="20%">点赞数</td>
                <td width="30%">{{ DetailsList.likeCount }}</td>
                <td class="title"  width="20%">评分人数</td>
                <td width="30%">{{ DetailsList.scoreCount }}</td>
              </tr>
              <tr>
                <td class="title" width="20%">活动评分</td>
                <td width="30%">{{ DetailsList.score }}</td>
              </tr>
            </table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="评论" name="review">
          <h2 style="font-size: 18px;padding-bottom: 10px;">用户评论<span style="font-size: 14px;">({{reviewList.length}}条)</span> </h2> 
          <ul class="review" style="height:100% ;overflow: auto;">
            <li style="position: relative;height: 120px;" v-for="(item, i) in reviewList" :key="i">
              <img style="width: 30px;height: 30px;border-radius: 50%;position: absolute;top: 10px;left: 10px;" :src="item.zheadPhotoURL" alt="">
              <p style="position: absolute;top: 17px;left: 52px;">{{ item.name }}</p>
              <p style="position: absolute;top: 50px;left: 52px;font-size: 14px;font-weight: 600;">{{ item.text }}</p>
              <p style="position: absolute;top: 80px;left: 52px;">{{ item.time }} <span class="w" @click="delreview(item)">删除评论</span></p>
            </li>
          </ul>
        </el-tab-pane>

        <el-tab-pane label="数据统计" name="sextus" style="width: 100%;height: 100%;background-color: rgb(235, 236, 237);overflow:auto;">
          <!-- <div @click="cscs()">cscs</div> -->
          <div style="width: 100%;height: 14px;background-color: rgb(235, 236, 237);"></div>
          <div ref="collegeStatistics" style="width:98%;height: 400px;background-color: #fff;margin-left:1%;"></div>

          <!-- <div ref="peopleNumList"  style="width:49%;height: 400px;background-color: rgb(255, 255, 255);margin-left:1%;float: left;margin-top:14px"></div> -->

          <div ref="activityNum"  style="width:48%;height: 400px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:14px"></div>

          <!-- <div ref="scoreNumByScore"  style="width:49%;height: 400px;background-color: rgb(255, 255, 255);margin-left:1%;float: left;margin-top:14px;margin-bottom:20px"></div> -->

          <div ref="peopleNumByDegree"  style="width:48%;height: 400px;background-color: rgb(255, 255, 255);margin-left:1%; float: left;margin-top:14px"></div>
        
        </el-tab-pane>

      </el-tabs>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      Count1: 0,
      pageSize1: 10,
      pageIndex1: 1,
      Count2: 0,
      pageSize2: 10,
      pageIndex2: 1,
      Count3: 0,
      pageSize3: 10,
      pageIndex3: 1,
      Count4: 0,
      pageSize4: 10,
      pageIndex4: 1,
      thirdName: "",
      fourthName: "",
      thefifthName: "",
      activeName: "sextus",
      secondName: "", //第一个页面条件
      secondSelection: [], //预报名多选数组
      FourthSelection: [], //志愿者多选数组
      BeforehandData: [],
      applyListData: [],
      VolunteerList: [], //志愿者
      SignInList: [], //签到
      reviewList: [], //评论
      StatisticsList: [],
      DetailsList: {},
      EventNo: "",
    };
  },
  created() { },
  methods: {
    query4() {
      this.pageSize4 = 10;
      this.pageIndex4 = 1;
      this.GetSignInList();
    },
    query3() {
      this.pageSize3 = 10;
      this.pageIndex3 = 1;
      this.GetVolunteerList();
    },
    query2() {
      this.pageSize2 = 10;
      this.pageIndex2 = 1;
      this.GetapplyList();
    },
    query1() {
      this.pageSize1 = 10;
      this.pageIndex1 = 1;
      this.GetBeforehand();
    },
    handleCurrentChange1(val) {
      this.pageIndex1 = val;
      this.GetBeforehand();
    },
    handleCurrentChange2(val) {
      this.pageIndex2 = val;
      this.GetapplyList();
    },
    handleCurrentChange3(val) {
      this.pageIndex3 = val;
      this.GetVolunteerList();
    },
    handleCurrentChange4(val) {
      this.pageIndex4 = val;
      this.GetSignInList();
    },
    selected(row, index) {
      if (row.statusStr != "待审核") {
        return false;//不可勾选
      } else {
        return true;//可勾选
      }
    },
    selected2(row, index) {
      if (row.status !== "1") {
        return false;//不可勾选
      } else {
        return true;//可勾选
      }
    },
    SecondConsent() {
      if (this.secondSelection.length == 0) {
        this.Global.request_failure("您未选中需要通过的人员信息！")
      } else {
        this.$Http_Post("/activitymanagement/updateeventregister", {eventRegisterKeys: this.secondSelection,status: '2'}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.GetBeforehand();
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },
    delreview(item) {
      this.$Http_Post("/activitymanagement/deleventcomment", { commentKey: item.commentKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GetreviewList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    fourthConsent() {
      if (this.FourthSelection.length == 0) {
        this.Global.request_failure("您未选中需要通过的人员信息");
      } else {
        this.$Http_Post("/activitymanagement/updateeventvolunteer", {eventVolunteerKeys: this.FourthSelection,status: "2"}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.GetVolunteerList();
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      }
    },



    UpdateEventVolunteer(row, Status) {
      var EventNo = []
      EventNo.push(row.eventVolunteerKey)
      this.$Http_Post("/activitymanagement/updateeventvolunteer", {
        eventVolunteerKeys: EventNo,
        status: Status,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.GetVolunteerList();
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },
    UpdateApply(eventRegisterKey,vai) {
      var oops = []
      oops.push(eventRegisterKey)
      this.$Http_Post("/activitymanagement/updateeventregister", {
        eventRegisterKeys: oops,
        status: vai,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message)
          this.GetBeforehand();
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },
    handleSecondSelection(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].eventRegisterKey);
      }
      this.secondSelection = lsc;
    },
    handleFourthSelection(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].eventVolunteerKey);
      }
      this.FourthSelection = lsc;
    },
    handleClick(tab, event) {
      if (tab.name == "second") {
        this.GetBeforehand();
      } else if (tab.name == "third") {
        this.GetapplyList();
      } else if (tab.name == "fourth") {
        this.GetVolunteerList();
      } else if (tab.name == "thefifth") {
        this.GetSignInList();
      } else if (tab.name == "sextus") {
        this.$nextTick(() => {
          this.College_statistics();
          this.PeopleNum();
          this.ActivityNum();
        });
      } else if(tab.name == "review") {
        this.GetreviewList();
      }
    },
    daochu() {
      this.$Http_Post("/activitymanagement/exportapplyList", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize2,pageIndex: this.pageIndex2,query: this.thirdName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },

    query4daochu() {
      this.$Http_Post("/activitymanagement/exportsigninlist", { eventKey: Number(this.$route.query.id), pageSize: this.pageSize2, pageIndex: this.pageIndex2, query: this.thirdName }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },

    GetreviewList() {
      this.$Http_Post("/activitymanagement/geteventcommentlist", { eventKey: Number(this.$route.query.id), pageSize: this.pageSize1, pageIndex: this.pageIndex1, query: this.secondName }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.reviewList = res.Data;
        }
      });
    },

    GetBeforehand() {
      this.$Http_Post("/activitymanagement/getbeforehand", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize1,pageIndex: this.pageIndex1,query: this.secondName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.BeforehandData = res.Data;
          this.Count1 = res.Counts;
        }
      });
    },

    GetVolunteerList() {
      this.$Http_Post("/activitymanagement/getvolunteerlist", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize3,pageIndex: this.pageIndex3,query: this.fourthName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.VolunteerList = res.Data;
          this.Count3 = res.Counts;
        }
      });
    },

    fourthConsentdaochu() {
      this.$Http_Post("/activitymanagement/exportvolunteerlist", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize3,pageIndex: this.pageIndex3,query: this.fourthName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location.href = res.Data;
        } else {
          this.Global.request_failure(res.Message)
        }
      });
    },

    GetapplyList() {
      this.$Http_Post("/activitymanagement/getapplylist", {eventKey: Number(this.$route.query.id),pageSize: this.pageSize2,pageIndex: this.pageIndex2,query: this.thirdName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.applyListData = res.Data;
          this.Count2 = res.Counts;
        }
      });
    },
    GetSignInList() {
      this.$Http_Post("/activitymanagement/getsigninlist", { eventKey: Number(this.$route.query.id),pageSize: this.pageSize4,pageIndex: this.pageIndex4,query: this.thefifthName}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.SignInList = res.Data;
          this.Count4 = res.Counts;
        }
      });
    },

    GetStatisticsList() {
      this.$Http_Post("/activitymanagement/getstatisticslist", { eventKey: Number(this.$route.query.id) }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.StatisticsList = res.Data;
          this.collegeStatistics(res.Data.collegeStatistics);
          // this.peopleNumList(res.Data.peopleNumList);
          this.activityNum(res.Data.activityNum);
          // this.scoreNumByScore(res.Data.scoreNumByScore);
          this.peopleNumByDegree(res.Data.peopleNumByDegree);
        }
      });
    },
    collegeStatistics(data) {
      let list1 = []
      let list2 = []
      let list3 = []
      for (var i = 0; i < data.length; i++) {
        list1.push(data[i].deptName)
        list2.push(data[i].manCount)
        list3.push(data[i].womanCount)
      }
      var myChart = this.$echarts.init(this.$refs.collegeStatistics);
      var option = {
        title: {
          text: '各学院参加活动人数',
          left: '20px',
          top: '10px',
        },
        legend: {
          top: '20px',
          textStyle: {
            color: '#000',//字体颜色
          },
          itemHeight: 10,
        },
        color: ["#00bb7a", "#ff9502"],
        tooltip: {
          trigger: 'axis',
          axisPointer: {//坐标轴指示器，坐标轴触发有效
            type: 'shadow'//默认为直线，可选为：'line' | 'shadow'
          },
        },
        xAxis: {
          type: 'category',
          nameTextStyle: {//y轴上方单位的颜色
            color: '#000'
          },
          axisLabel: {
            show: true,
            color: '#000',
            fontSize: 12
          },
          data: list1
          // data: ['Mon', 'Tue', 'Wed', 'Thu']
        },

        yAxis: {
          type: 'value',
          splitLine: { //网格线
            lineStyle: {
              type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
            }
          }
        },
        series: [
          { type: 'bar', name: '男', barWidth: 20, data: list2 },
          { type: 'bar', name: '女', barWidth: 20, data: list3 }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    peopleNumList(data) {
      var myChart = this.$echarts.init(this.$refs.peopleNumList);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'//'shadow' as default; can also be 'line' or 'shadow'
          }
        },
        title: {
          text: '报名/签到/评分人数统计',
          left: '20px',
          top: '10px',
        },
        color: ["#00bb7a", "#ff9502"],
        legend: {
          top: '10px'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['报名人数', '签到人数', '评分人数']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '男',
            type: 'bar',
            stack: 'total',
            barWidth: 30,
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: [data[0].manCount, data[1].manCount, data[2].manCount]
          },
          {
            name: '女',
            type: 'bar',
            stack: 'total',
            label: {
              show: true
            },
            emphasis: {
              focus: 'series'
            },
            data: [data[0].womanCount, data[1].womanCount, data[2].womanCount]
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

    },
    activityNum(data) {
      var myChart = this.$echarts.init(this.$refs.activityNum);
      var option = {
        title: {
          text: '参加活动男女占比',
          left: '20px',
          top: '10px'
        },
        color: ["#00bb7a", "#ff9502"],
        tooltip: {
          trigger: 'item'
        },
        legend: {

          right: '20px',
          top: '10px'
        },
        series: [
          {
            type: 'pie',
            radius: '50%',
            data: [
              { value: data[0].manCount, name: '男' },
              { value: data[0].womanCount, name: '女' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    scoreNumByScore(data) {
      let list1 = []
      let list2 = []
      let list3 = []
      for (var i = 0; i < data.length; i++) {
        list1.push(data[i].score)
        list2.push(data[i].manCount)
        list3.push(data[i].womanCount)
      }
      var myChart = this.$echarts.init(this.$refs.scoreNumByScore);
      var option = {
        title: {
          text: '活动评分人数占比',
          left: '20px',
          top: '10px',
        },
        legend: {
          top: '20px',
          right: '20px',
          textStyle: {
            color: '#000',//字体颜色
          },
          itemHeight: 10,
        },
        color: ["#00bb7a", "#ff9502"],
        tooltip: {
          trigger: 'axis',
          axisPointer: {//坐标轴指示器，坐标轴触发有效
            type: 'shadow'//默认为直线，可选为：'line' | 'shadow'
          },
        },
        xAxis: {
          type: 'value',
          splitLine: { //网格线
            lineStyle: {
              type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
            }
          }
        },
        yAxis: {
          type: 'category',
          nameTextStyle: {//y轴上方单位的颜色
            color: '#000'
          },
          axisLabel: {
            show: true,
            color: '#000',
            fontSize: 12
          },
          data: list1
        },
        series: [
          { type: 'bar', name: '男', barWidth: 20, data: list2 },
          { type: 'bar', name: '女', barWidth: 20, data: list3 }
        ]
      };
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },

    peopleNumByDegree(data) {
      let list1 = []
      let list2 = []
      for (var i = 0; i < data.length; i++) {
        list1.push(data[i].degree)
        list2.push(data[i].counts)
      }
      var myChart = this.$echarts.init(this.$refs.peopleNumByDegree);
      var option = {
        title: {
          text: '参加活动人员年级统计',
          left: '20px',
          top: '10px',
        },
        xAxis: {
          type: 'category',
          data: list1
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: list2,
            type: 'line',
            lineStyle: {
              color: '#00bb7a',
              width: 2
            },
            symbolSize: 10,
            symbol: 'circle',
            color: '#00bb7a'
          }
        ]
      };

      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

    },
    GetData() {
      let _this = this;
      let from = {eventKey:this.EventNo}
      this.$Http_Post("/activitymanagement/fxonlineeventplan", { eventKey: this.EventNo }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.DetailsList = res.Data;
        }
      });
    },
  },
  mounted: function () {
    this.EventNo = this.$route.query.id;
    this.GetData();
    this.GetStatisticsList();
  },
};
</script>
<style>
.Details .el-tabs{height: 100%;}
.Details .el-tabs__content{height: calc(100% - 80px);}

.Details #pane-review{height: 100%;}
.tabs .title {height: 40px;background-color: rgb(242, 242, 242);border-style: none;border-color: unset;font-size: 14px;padding: 0px;text-align: center;line-height: 20px;font-weight: normal;font-style: normal;border: 1px solid rgb(221, 221, 221);
}
.cotent table tr td {border: 1px solid rgb(221, 221, 221);padding-left: 10px;}
.Details {height: 100%;}
.activity_Details {padding: 10px;height: 140px;background-color: #fff;}
.activity_Details .spanstyle {font-family: SourceHanSansSC;font-weight: 400;font-size: 14px;color: rgba(102, 102, 102, 1);font-style: normal;text-decoration: none;letter-spacing: 0px;padding: 10px;}
.activity_Details .spanstyle span {
  padding: 5px;
  margin: 10px;
  font-weight: 700;
}

.Details .tabs {
  height: calc(100% - 200px);
  padding: 15px;
  margin-top: 10px;
  background-color: #fff;
}

.College_statistics {
  width: 100%;
  height: 300px;
}
</style>
